import type { AxiosInstance } from 'axios'

import { CategoryDetailInterface } from '../../interfaces/category'

export const getCategoryDetail = (api: AxiosInstance) => (
  categoryId: string
): Promise<CategoryDetailInterface> =>
  api.get(`/v1.0/admin/categories/${categoryId}`)
